import React from 'react';
import styles from './styles';
import {DataTableContext} from '../../Utils/DataTableContext';
import {Button} from '@xpertdox_js/xdcomponents';
import { trackActivity } from '../../../../utils/activityTracker'
import { UserContext } from '../../../../Context/UserContext'
import { InstanceContext } from '../../../../InstanceContext'

const HeaderTab = props => {

  const {controller} = React.useContext(DataTableContext);
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  const clearSearch = () => {
    handleActivityLogUpdate(`HeaderTab.clearSearch`)
    controller.searchingHeader = null;
    controller.reset();
    controller.render();
  }

  const openModal = (e) => {
    // e.preventDefault();
    // e.stopPropagation();
    console.log('open modal again')
    handleActivityLogUpdate(`HeaderTab.openModal`)
    controller.searchingHeader = props.index;
    controller.searchActive = true;
    controller.render()
  }
  let containerStyles = {...styles.container};
  if (props.last) {
    containerStyles.left = 'auto';
    containerStyles.right = 0;
  }
  console.log('render')

  return (
    <div style={containerStyles}>
      <div style={styles.textWrap} onClick={openModal}>
        <span style={styles.defaultText}>Searching For:</span>
        <span style={styles.queryText}>"{controller.queryString}"</span>
      </div>
      <Button
        onClick={clearSearch}
        styles={styles.clearBtn}
        hoverStyles={styles.clearBtnHov}
      >
        <svg style={styles.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"/></svg>
      </Button>
    </div>
  )
}

export default HeaderTab;
